<script>
export default {
    name: 'CartError',
    props: {
        icon: null,
        text: null,
        event: null,
        eProp: null,
    },
    methods: {
        editTime() {
            if (typeof this.event === 'string') this.event(this.eProp ? this.eProp : undefined)
            else this.event()
        },
    },
}
</script>

<template lang="pug">
.card.highlight.shadow-lg-2.flat-card
    .card-body
        .d-flex.align-items-start.cart-error-message(:class="{'mb-4': event}")
            .icon-wrapper.text-danger
                icon.fa-2x(:icon="icon")
                icon.icon-sub(icon="fa-solid fa-exclamation-triangle")
            h4.my-0.text-danger {{text}}
        button.btn.btn-primary.btn-block.btn-xs(@click="editTime" v-if="event")
            slot
</template>
